// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-light: #f4f4f4;
  --bg-dark: #1a1a1a;
  --text-light: #333;
  --text-dark: #f2f2f2;
  --primary: #7352ff;
  --secondary: #54b7ff;
  --accent: #ffe156;
  --white: #fff;
}

body {
  font-family: 'Segoe UI', 'Poppins', sans-serif;
  margin: 0;
  background: var(--bg-light);
  color: var(--text-light);
  transition: all 0.3s ease;
}

.dark-mode {
  background: var(--bg-dark);
  color: var(--text-dark);
}

a {
  color: inherit;
  text-decoration: none;
}

h1, h2, h3 {
  margin: 0;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.2rem 4%;
  background: var(--primary);
  color: var(--white);
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.logo {
  font-size: 1.8rem;
  font-weight: bold;
}

.navbar a {
  margin: 0 1rem;
  font-size: 1rem;
  color: var(--white);
  transition: 0.2s ease;
}

.navbar a:hover {
  color: var(--accent);
}

.dark-mode-toggle {
  margin-left: 1rem;
  background: transparent;
  border: 1px solid var(--white);
  color: var(--white);
  padding: 0.5rem 0.8rem;
  border-radius: 6px;
  cursor: pointer;
}

.section {
  padding: 5rem 8%;
}

.home, .about, .services, .pricing, .contact {
  padding: 5rem 8%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2rem;
}

.home-content, .about-content {
  flex: 1 1 500px;
}

.home-img img,
.about-img img {
  width: 100%;
  max-width: 500px;
  height: auto;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
}

.heading {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  color: var(--primary);
}

.services-container {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 2rem;
}

.services-box {
  background: #fff;
  padding: 2rem;
  border-radius: 14px;
  flex: 1 1 260px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  text-align: center;
  transition: transform 0.3s;
}

.services-box:hover {
  transform: translateY(-5px);
}

.services-box i {
  font-size: 2.5rem;
  color: var(--primary);
  margin-bottom: 1rem;
}

.btn {
  margin-top: 1rem;
  display: inline-block;
  padding: 0.8rem 1.4rem;
  background: var(--primary);
  color: #fff;
  border-radius: 6px;
  transition: 0.3s;
}

.btn:hover {
  background: var(--secondary);
}

.social-media a {
  display: inline-block;
  margin-right: 0.5rem;
  font-size: 1.5rem;
  color: var(--primary);
}

.input-box {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.input-box input,
textarea {
  flex: 1 1 48%;
  padding: 1rem;
  font-size: 1rem;
  border-radius: 6px;
  border: 1px solid #ccc;
}

textarea {
  flex: 1 1 100%;
  resize: vertical;
}

.contact form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.footer {
  background: var(--primary);
  color: var(--white);
  padding: 2rem 4%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer a i {
  color: var(--white);
  font-size: 1.5rem;
}

.footer-iconTop a:hover {
  color: var(--accent);
}

/* Chatbot Styles */
.chatbot-toggle-wrapper {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 9999;
}

.chatbot-toggle {
  background: var(--primary);
  color: white;
  border: none;
  border-radius: 50px;
  padding: 0.7rem 1.4rem;
  font-size: 0.95rem;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.chatbot-wrapper {
  position: fixed;
  bottom: 4.5rem;
  right: 2rem;
  width: 350px;
  height: 480px;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 6px 20px rgba(0,0,0,0.3);
}

/* Responsive */
@media screen and (max-width: 768px) {
  .navbar {
    flex-wrap: wrap;
    justify-content: center;
  }

  .services-container {
    flex-direction: column;
  }

  .chatbot-wrapper {
    width: 90%;
    right: 5%;
  }
}
/* App.css – globalne style */
body {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    background-color: #f7f9fc;
    color: #333;
    margin: 0;
    padding: 0;
}

.App {
    padding: 20px;
}
.back-btn {
  background-color: #f1f1f1;
  color: #333;
  padding: 10px 16px;
  border-radius: 8px;
  border: none;
  margin-bottom: 20px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.back-btn:hover {
  background-color: #ddd;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,8CAA8C;EAC9C,SAAS;EACT,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uCAAuC;EACvC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,eAAe;AACf;EACE;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,SAAS;EACX;AACF;AACA,6BAA6B;AAC7B;IACI,4DAA4D;IAC5D,yBAAyB;IACzB,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[":root {\n  --bg-light: #f4f4f4;\n  --bg-dark: #1a1a1a;\n  --text-light: #333;\n  --text-dark: #f2f2f2;\n  --primary: #7352ff;\n  --secondary: #54b7ff;\n  --accent: #ffe156;\n  --white: #fff;\n}\n\nbody {\n  font-family: 'Segoe UI', 'Poppins', sans-serif;\n  margin: 0;\n  background: var(--bg-light);\n  color: var(--text-light);\n  transition: all 0.3s ease;\n}\n\n.dark-mode {\n  background: var(--bg-dark);\n  color: var(--text-dark);\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\nh1, h2, h3 {\n  margin: 0;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.2rem 4%;\n  background: var(--primary);\n  color: var(--white);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n}\n\n.logo {\n  font-size: 1.8rem;\n  font-weight: bold;\n}\n\n.navbar a {\n  margin: 0 1rem;\n  font-size: 1rem;\n  color: var(--white);\n  transition: 0.2s ease;\n}\n\n.navbar a:hover {\n  color: var(--accent);\n}\n\n.dark-mode-toggle {\n  margin-left: 1rem;\n  background: transparent;\n  border: 1px solid var(--white);\n  color: var(--white);\n  padding: 0.5rem 0.8rem;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.section {\n  padding: 5rem 8%;\n}\n\n.home, .about, .services, .pricing, .contact {\n  padding: 5rem 8%;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 2rem;\n}\n\n.home-content, .about-content {\n  flex: 1 1 500px;\n}\n\n.home-img img,\n.about-img img {\n  width: 100%;\n  max-width: 500px;\n  height: auto;\n  border-radius: 16px;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.1);\n}\n\n.heading {\n  font-size: 2.5rem;\n  margin-bottom: 2rem;\n  color: var(--primary);\n}\n\n.services-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2rem;\n  margin-top: 2rem;\n}\n\n.services-box {\n  background: #fff;\n  padding: 2rem;\n  border-radius: 14px;\n  flex: 1 1 260px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.05);\n  text-align: center;\n  transition: transform 0.3s;\n}\n\n.services-box:hover {\n  transform: translateY(-5px);\n}\n\n.services-box i {\n  font-size: 2.5rem;\n  color: var(--primary);\n  margin-bottom: 1rem;\n}\n\n.btn {\n  margin-top: 1rem;\n  display: inline-block;\n  padding: 0.8rem 1.4rem;\n  background: var(--primary);\n  color: #fff;\n  border-radius: 6px;\n  transition: 0.3s;\n}\n\n.btn:hover {\n  background: var(--secondary);\n}\n\n.social-media a {\n  display: inline-block;\n  margin-right: 0.5rem;\n  font-size: 1.5rem;\n  color: var(--primary);\n}\n\n.input-box {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.input-box input,\ntextarea {\n  flex: 1 1 48%;\n  padding: 1rem;\n  font-size: 1rem;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n}\n\ntextarea {\n  flex: 1 1 100%;\n  resize: vertical;\n}\n\n.contact form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.footer {\n  background: var(--primary);\n  color: var(--white);\n  padding: 2rem 4%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.footer a i {\n  color: var(--white);\n  font-size: 1.5rem;\n}\n\n.footer-iconTop a:hover {\n  color: var(--accent);\n}\n\n/* Chatbot Styles */\n.chatbot-toggle-wrapper {\n  position: fixed;\n  bottom: 2rem;\n  right: 2rem;\n  z-index: 9999;\n}\n\n.chatbot-toggle {\n  background: var(--primary);\n  color: white;\n  border: none;\n  border-radius: 50px;\n  padding: 0.7rem 1.4rem;\n  font-size: 0.95rem;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.2);\n}\n\n.chatbot-wrapper {\n  position: fixed;\n  bottom: 4.5rem;\n  right: 2rem;\n  width: 350px;\n  height: 480px;\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 6px 20px rgba(0,0,0,0.3);\n}\n\n/* Responsive */\n@media screen and (max-width: 768px) {\n  .navbar {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .services-container {\n    flex-direction: column;\n  }\n\n  .chatbot-wrapper {\n    width: 90%;\n    right: 5%;\n  }\n}\n/* App.css – globalne style */\nbody {\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    background-color: #f7f9fc;\n    color: #333;\n    margin: 0;\n    padding: 0;\n}\n\n.App {\n    padding: 20px;\n}\n.back-btn {\n  background-color: #f1f1f1;\n  color: #333;\n  padding: 10px 16px;\n  border-radius: 8px;\n  border: none;\n  margin-bottom: 20px;\n  cursor: pointer;\n  font-weight: bold;\n  transition: background-color 0.3s ease;\n}\n\n.back-btn:hover {\n  background-color: #ddd;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
